import Vue        from 'vue'
import Vuex       from 'vuex'
import actions    from './actions'
import mutations  from './mutations'
import getters    from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
      uname:"",
      isActive: false,
      isClose:false,
      //页面按钮注入状态
      //用户管理

      btn_0412:false,
      btn_0413:false,
      btn_0414:false,
      btn_0415:false,
      btn_0416:false,
      btn_0417:false,

      btnlist:[],
  },
  getters,
  mutations,
  actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js